import embedInstagram from './components/embed-instagram.js';
import embedPlaybuzz from './components/embed-playbuzz.js';
import embedTwitter from './components/embed-twitter.js';
import gallery from './components/gallery.js';
import lazyImage from './components/lazy-image.js';
import lineClamp from './components/line-clamp.js';
import navigationMarquee from './components/navigation-marquee.js';
import navigationNew from './components/navigation-new.js';
import share from './components/share.js';
import './components/web-vitals.js';

export const components = {
  "embed-instagram": embedInstagram,
  "embed-playbuzz": embedPlaybuzz,
  "embed-twitter": embedTwitter,
  "gallery": gallery,
  "lazy-image": lazyImage,
  "line-clamp": lineClamp,
  "navigation-marquee": navigationMarquee,
  "navigation-new": navigationNew,
  "share": share
};

export const syncNames = ["navigation-new","lazy-image"];

